var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikewhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.657,
    height: 68.91,
    viewBox: "0 0 73.657 68.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M102.776,127.992a7.362,7.362,0,0,0-5.485-12.276H83a47.607,47.607,0,0,0,2.02-12.441v-2.454A9.833,9.833,0,0,0,75.194,91H72.739a2.455,2.455,0,0,0-2.382,1.859L69.02,98.21c-1.874,7.493-7.824,15.761-13.982,17.264a7.376,7.376,0,0,0-6.852-4.668H33.455A2.456,2.456,0,0,0,31,113.261v44.194a2.456,2.456,0,0,0,2.455,2.455H48.187a7.373,7.373,0,0,0,6.649-4.2l8.436,2.812a26.947,26.947,0,0,0,8.541,1.386H92.381a7.368,7.368,0,0,0,6.848-10.08,7.362,7.362,0,0,0,3.547-12.018,7.351,7.351,0,0,0,0-9.821ZM50.642,152.544A2.458,2.458,0,0,1,48.187,155H35.91V115.716H48.187a2.458,2.458,0,0,1,2.455,2.455Zm41.739-22.1h4.91a2.455,2.455,0,1,1,0,4.91h-4.91a2.455,2.455,0,0,0,0,4.91h4.91a2.455,2.455,0,1,1,0,4.91h-4.91a2.455,2.455,0,0,0,0,4.91,2.455,2.455,0,0,1,0,4.91H71.812a22.049,22.049,0,0,1-6.989-1.134l-9.271-3.09V120.394c3.851-.732,7.621-3.171,11.024-7.163A35.825,35.825,0,0,0,73.783,99.4l.872-3.491h.539a4.916,4.916,0,0,1,4.91,4.91v2.454c0,3.3-1.031,9.62-2.35,12.441H72.739a2.455,2.455,0,1,0,0,4.91H97.291a2.455,2.455,0,1,1,0,4.91h-4.91a2.455,2.455,0,1,0,0,4.91Z",
    transform: "translate(-31 -91)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(9.97 54.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-0.1 -0.087)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikewhite);
export default __webpack_public_path__ + "static/media/likewhite.9df1555037e9f218ef2d80c79757031c.svg";
export { ForwardRef as ReactComponent };